import Flex from '@Components/Bases/Flex';
import { Components, Theme } from '@mui/material';

const dataGridTheme: Components<Omit<Theme, 'components'>> = {
  MuiDataGrid: {
    defaultProps: {
      columnHeaderHeight: 48,
      rowHeight: 44,
      pageSizeOptions: [10, 20, 50, 100],
      autoHeight: true,
      disableColumnFilter: true,
      showColumnVerticalBorder: true,
      hideFooterSelectedRowCount: true,
      hideFooter: true,
      slots: {
        noRowsOverlay: () => (
          <Flex
            bgcolor={'white'}
            justifyContent={'center'}
            alignItems={'center'}
            p={4}
          >
            ไม่มีข้อมูล
          </Flex>
        ),
      },
      slotProps: {
        footer: {
          total: 0,
          pagination: {
            count: 0,
            page: 0,
            rowsPerPage: 10,
          },
        },
        loadingOverlay: {
          variant: 'skeleton',
        },
      },
    },
    styleOverrides: {
      root: ({ theme: { unstable_sx: sx } }) =>
        sx({
          border: 'none',
          borderBottom: '1px solid hsla(0, 0%, 94%, 1)',
          borderRadius: 2,
        }),
      columnHeader: ({ theme: { palette, unstable_sx: sx } }) =>
        sx({
          backgroundColor: palette.grey[200],
          p: 1,
        }),
      'columnHeader--withLeftBorder': ({
        theme: { palette, unstable_sx: sx },
      }) => sx({ borderLeft: `2px solid ${palette.common.white}` }),
      'columnHeader--withRightBorder': ({
        theme: { palette, unstable_sx: sx },
      }) => sx({ borderRight: `2px solid ${palette.common.white}` }),

      columnHeaderTitle: ({ theme: { unstable_sx: sx } }) =>
        sx({ fontWeight: 800 }),

      columnSeparator: ({ theme: { unstable_sx: sx, ...theme } }) =>
        sx({
          '&.MuiDataGrid-columnSeparator': {
            visibility: 'visible',
            color: theme.palette.common.white,
          },
        }),
      row: ({ theme: { palette, unstable_sx: sx } }) =>
        sx({
          backgroundColor: `${palette.common.white} !important`,
          cursor: 'default',
        }),
      cell: ({ theme: { unstable_sx: sx } }) =>
        sx({
          p: 1,
          lineHeight: 'inherit',
          alignItems: 'flex-start',
        }),
    },
  },
};

export default dataGridTheme.MuiDataGrid;
